import { useCallback, useRef } from "react";
import useHintStore from "../../store/hintStateStore";
import Modal from "react-bootstrap/Modal";
import styles from "./LearnMoreModal.module.css";
import CloseButton from "./CloseButton";
import { styleHelper } from "../../helpers/commonFunctions";
const LearnMoreModal = () => {
  const { open, setOpen, link } = useHintStore();
  const handleClose = useCallback(() => {
    setOpen(false, "");
  }, [setOpen]);
  const iframeContent = useRef<null | HTMLIFrameElement>(null);
  const randomNumberInRange = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  return (
    <Modal
      centered={true}
      show={open}
      size="lg"
      onHide={handleClose}
      radius="40px"
    >
      <div
        className={`${styles.modal_background} vas-d-flex vas-flex-column vas-gap-4 `}
      >
        <div className="vas-w-100" style={styleHelper({ height: "5vh" })}>
          <CloseButton handleClose={handleClose} />
        </div>
        <iframe
          title="learn-more-iframe"
          key={randomNumberInRange(10000, 999)}
          src={link}
          className="vas vas-w-100"
          style={styleHelper({ height: "80vh", overflowY: "hidden" })}
          ref={iframeContent}
        />
      </div>
    </Modal>
  );
};

export default LearnMoreModal;
